<template>
  <v-col>
    <v-row justify="end">
      <v-btn color="primary" class="mb-6 mr-3" @click="downloadGiacenza">Scarica XLS Giacenze</v-btn>
      <v-btn color="primary" class="mb-6 mr-3" @click.stop="triggerDialogZip(item)">Scarica Archivio Zip</v-btn>
    </v-row>
    <v-card>
      <v-card-title class="pb-8">
        <v-btn color="primary" @click="CHANGE_USATO_CLIENTI_COMPONENT('Insert')">Nuova dichiarazione di vendita</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Cerca" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="usati" class="elevation-1" :search="search" :items-per-page="100"
        :footer-props="{
          itemsPerPageAllText: 'Tutti',
          itemsPerPageOptions: [15, 50, 100, -1],
          itemsPerPageText: 'Articoli usati per pagina',
        }">
        <template v-slot:top>
          <edit-form :item="selectedItem" @edit-submit="triggerSnack($event)" />
        </template>

        <template v-slot:item.in_stock="{ item }">
          <v-icon color="red" v-if="item.in_stock === null">
            mdi-close
          </v-icon>
          <v-icon color="green" v-else>
            mdi-check
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="fetchUsati">Ricarica</v-btn>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span>{{ new Date(item.created_at).toLocaleString('it-IT', {
          day: '2-digit', month: '2-digit', year: 'numeric'
          })
          }}</span>
        </template>

        <template v-slot:item.customer="{ item }">
          <span>{{ item.name }} {{ item.surename }}</span>
        </template>

        <template v-slot:item.cost="{ item }">
          <span>{{ item.cost || '0' }}€</span>
        </template>

        <template v-slot:item.price="{ item }">
          <span>{{ item.price || '0' }}€</span>
        </template>

        <template v-slot:item.action="{ item }">
          <td class="actions">
            <v-btn color="blue" elevation="1" outlined small @click.stop="triggerDialogInStock(item)"
              v-if="item.in_stock === null">
              <v-icon small>
                mdi-database-arrow-left
              </v-icon>
            </v-btn>
            <v-btn color="green" elevation="1" outlined small @click.stop="triggerDialogPDF(item)">
              <v-icon small>
                mdi-file-document-outline
              </v-icon>
            </v-btn>
            <v-btn color="orange" elevation="1" outlined small @click.stop="edit(item)">
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn color="red" elevation="1" outlined small @click.stop="triggerDialog(item)">
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </td>
        </template>

      </v-data-table>
      <snack-notification :snack="snack" />
    </v-card>

    <!-- dialog -->
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminare dichiarazione di vendita?</v-card-title>

          <v-card-text>
            Confermando, la dichiarazione di vendita verrà eliminata dal database
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="remove">
              Conferma
            </v-btn>

            <v-btn color="primary" @click="dialog = false">
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialogPDF" max-width="550">
        <v-card>
          <v-card-title class="headline">Vuoi stampare la dichiarazione di vendita?</v-card-title>


          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="pdfDownload(item)">
              Conferma
            </v-btn>

            <v-btn color="primary" @click="dialogPDF = false">
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialogInStock" max-width="550">
        <v-card>
          <v-card-title class="headline">Vuoi aggiungere il dispositivo al magazzino?</v-card-title>


          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="addToStock(item)">
              Conferma
            </v-btn>

            <v-btn color="primary" @click="dialogInStock = false">
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialogZip" max-width="550">
        <v-card>
          <v-card-title class="headline">Seleziona il periodo</v-card-title>
          <v-container fluid>
            <v-text-field v-model="checkedYear" min="2022" label="Anno" type="number" required></v-text-field>
            <v-card class="pa-2">
              <v-row>
                <v-col cols="4">
                  <v-checkbox v-model="checkedMonths" label="Gennaio" value="GEN"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Aprile" value="APR"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Luglio" value="LUG"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Ottobre" value="OTT"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="checkedMonths" label="Febbraio" value="FEB"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Maggio" value="MAG"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Agosto" value="AGO"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Novembre" value="NOV"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="checkedMonths" label="Marzo" value="MAR"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Giugno" value="GIU"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Settembre" value="SET"></v-checkbox>
                  <v-checkbox v-model="checkedMonths" label="Dicembre" value="DIC"></v-checkbox>
                </v-col>
              </v-row>
            </v-card>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="downloadArchivioZip">
              Conferma
            </v-btn>

            <v-btn color="primary" @click="dialogZip = false">
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </v-col>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

import EditForm from './EditForm'
import SnackNotification from './../../SnackNotification'

export default {
  name: 'Index',
  components: {
    EditForm,
    SnackNotification
  },
  data: () => ({
    search: '',
    dialog: false,
    dialogPDF: false,
    dialogInStock: false,
    dialogZip: false,
    checkedMonths: [],
    checkedYear: new Date().getFullYear(),
    headers: [
      { text: 'In stock', value: 'in_stock', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Prog.', value: 'progressive', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Data', value: 'created_at', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'IMEI', value: 'serial_number', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'EAN', value: 'ean', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Brand', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Modello', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Costo', value: 'cost', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Cliente', value: 'customer', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Telefono', value: 'phone', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Grado Estetico', value: 'grade', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: 'Descrizione', value: 'description', class: 'subtitle-2 primary--text font-weight-bold' },
      { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
    ],
    usati: [],
    newSecondHandForStock: {
      brand: null,
      model: null,
      disk_space: null,
      ram: null,
      color: null,
      description: null,
      serial_number: null,
      ean: null,
      cost: null,
      price: null,
      grade: null,
      is_new: null,
      is_art_17: null,
      smartphone_id: null,
      posix: null,
      supplier_id: null
    },
    item: {},
    snack: {
      error: null,
      visible: null,
      message: null
    },
    config: {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      },
    },
    configPDF: {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
      },
      responseType: 'arraybuffer',
    },
    configZIP: {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
        'Accept': 'application/zip'
      },
      responseType: 'arraybuffer',
    },
  }),

  computed: {
    selectedItem() {
      return this.item
    }
  },

  methods: {
    ...mapMutations([
      'CHANGE_USATO_CLIENTI_COMPONENT',
      'CHANGE_USATO_CLIENTI_EDIT'
    ]),

    async fetchUsati() {
      try {
        let {
          data
        } = await axios.get(`${process.env.VUE_APP_API}/secondHand/customer/fetch`, this.config)

        this.usati = data
      } catch (error) {

        console.log(error)

        this.usati = []
      }
    },

    async pdfDownload(payload) {

      try {
        let {
          data
        } = await axios.post(`${process.env.VUE_APP_API}/pdfDownload`, { payload: payload }, this.configPDF);

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;

        const filename = payload.pdf_path.substring(payload.pdf_path.lastIndexOf('/')+1)

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        this.dialogPDF = false;
      } catch (error) {
        console.log(error)
        alert('Si è verificato un errore: DVP non presente')
        this.dialogPDF = false;
      }
    },

    async pdfDelete(payload) {

      try {

        await axios.post(`${process.env.VUE_APP_API}/pdfDelete`, { payload: payload }, this.config);

      } catch (error) {

        console.log(error)
        this.dialogPDF = false;

      }
    },

    async addToStock(payload) {

      try {
        this.newSecondHandForStock.brand = payload.brand;
        this.newSecondHandForStock.model = payload.model;
        this.newSecondHandForStock.disk_space = payload.disk_space;
        this.newSecondHandForStock.ram = payload.ram;
        this.newSecondHandForStock.color = payload.color;
        this.newSecondHandForStock.description = payload.description;
        this.newSecondHandForStock.serial_number = payload.serial_number;
        this.newSecondHandForStock.ean = payload.ean;
        this.newSecondHandForStock.cost = payload.cost;
        this.newSecondHandForStock.price = payload.price;
        this.newSecondHandForStock.grade = payload.grade;
        this.newSecondHandForStock.posix = Math.floor(Date.now() / 1000);
        this.newSecondHandForStock.is_new = false;
        this.newSecondHandForStock.is_art_17 = false;
        this.newSecondHandForStock.supplier_id = 1;  // Fornitore Bytewood

        await axios.post(`${process.env.VUE_APP_API}/smartphones/create`, this.newSecondHandForStock, this.config);

        this.dialogInStock = false;
        this.fetchUsati();

      } catch (error) {

        console.log(error)
        this.dialogInStock = false;

      }
    },

    async downloadGiacenza() {

      let { data } = await axios.get(`${process.env.VUE_APP_API}/downloads/giacenza-dvp`, this.config)

      let fileURL = window.URL.createObjectURL(new Blob([data]))
      let fileLink = document.createElement('a')

      const name = `[${this.today}]report_giacenze_DVP.xls`

      fileLink.href = fileURL
      fileLink.setAttribute('download', name)
      document.body.appendChild(fileLink)

      fileLink.click()
    },

    async downloadArchivioZip() {      
      let payload = { year: this.checkedYear ,months: this.checkedMonths }
      let { data } = await axios.post(`${process.env.VUE_APP_API}/pdfSignedZipped`, { payload: payload }, this.configZIP)

      let fileURL = window.URL.createObjectURL(new Blob([data]))
      let fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', `Archivio_DVP.zip`)
      document.body.appendChild(fileLink)

      fileLink.click()
      this.dialogZip = false
    },

    edit(val) {
      this.item = val
      this.CHANGE_USATO_CLIENTI_EDIT(true)
    },

    async remove() {
      console.log('item', this.item)

      const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/secondHand/customer/delete`, { id: this.item.id }, this.config)

      if (data.status) {
        this.fetchUsati()
        await this.pdfDelete(this.item)
        this.dialog = false
      } else {
        alert('Si è verificato un errore.')
      }
    },


    triggerDialog(val) {
      this.item = val
      this.dialog = true
    },

    triggerDialogPDF(val) {
      this.item = val
      this.dialogPDF = true
    },

    triggerDialogInStock(val) {
      this.item = val
      this.dialogInStock = true
    },

    triggerDialogZip(val) {
      this.item = val
      this.dialogZip = true
    },

    triggerSnack(e) {
      if (e === 'reset') {

        this.snack = Object.assign({}, {
          error: null,
          visible: null,
          message: null
        })
      } else if (e === 'ok') {

        this.snack = Object.assign({}, {
          visible: true,
          error: false,
          message: 'Modificato correttamente!'
        })

        this.fetchUsati()
      } else if (e === 'error') {

        this.snack = Object.assign({}, {
          visible: true,
          error: true,
          message: 'Errore nella modifica.'
        })
      }
    }
  },

  async created() {
    await this.fetchUsati()
  },
}
</script>

<style scoped>
.actions {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  align-items: center;
}

.actions>button {
  margin-left: 10px;
}
</style>